import FieldDefs from './AdsFieldDefs.js'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.rsy-ads", FieldDefs),
            sortOrder: [
                {
                    field: 'found_at',
                    direction: 'desc',
                }
            ],
            additionalActions: []
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
